module.exports = __webpack_public_path__ + "static/media/demo-9.bfc6d5c8.jpg";